export type GetUsersResponse = {
  /**
   * The results of this get_general_codes response body.
   */
  userList: UserList[];
};

export type UserList = {
  userId: string;
  emplyNum?: string;
  userName: string;
  mlAdrs: string;
  delFlg: string;
  userRoleList: UserRoleList[];
};

export type UserRoleList = {
  roleCd: string;
  roleName: string;
  cvrgCd: string;
  primFlg: string;
};
